import { createReducer } from 'typesafe-actions'

import { ReadTradingHistoryResponseDto } from '@sparling/financial-common'
import { ActionTypes } from '../types'
import { getTradingHistoryRequest, getTradingHistorySuccess, getTradingHistoryFailure } from '../actions'
import { LoadingState } from '../../types'

const initialMetaState = {
  currentPage: 0,
  itemCount: 0,
  itemsPerPage: 0,
  totalItems: 0,
  totalPages: 0,
}

export type TradesState = {
  tradingHistory: {
    loading: LoadingState
    data: ReadTradingHistoryResponseDto
    error: Error | null
  }
}

export const initialState: TradesState = {
  tradingHistory: {
    loading: 'IDLE',
    data: {
      items: [],
      meta: initialMetaState,
    },
    error: null,
  },
}

export const trades = createReducer<TradesState, ActionTypes>(initialState)
  .handleAction(getTradingHistoryRequest, (state) => ({
    ...state,
    tradingHistory: {
      ...state.tradingHistory,
      loading: 'LOADING',
    },
  }))
  .handleAction(getTradingHistorySuccess, (state, { payload }) => ({
    ...state,
    tradingHistory: {
      ...state.tradingHistory,
      loading: 'SUCCESS',
      data: payload,
    },
  }))
  .handleAction(getTradingHistoryFailure, (state, { payload }) => ({
    ...state,
    tradingHistory: {
      ...state.tradingHistory,
      loading: 'ERROR',
      data: initialState.tradingHistory.data,
      error: payload,
    },
  }))
